export const datingAssets = {
  dating: {
    emerging: {
      emerging1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/emerging/generative-ai-agents.webp`,
      emerging2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/emerging/ar-vr.webp`,
      emerging3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/emerging/blockchain.webp`,
      emerging4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/emerging/iot-wearables.webp`,
    },
    benefits: {
      benefit1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/benefits/data-brokers.svg`,
      benefit2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/benefits/improved-customer-experience.svg`,
    },
    solutions: {
      solution1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/solutions/accuracy-of-matchmaking.svg`,
      solution2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/solutions/profile-safety-verification.svg`,
      solution3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/solutions/cross-platform.svg`,
      solution4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/solutions/top-notch-engagement.svg`,
    },
    whyKonstant: {
      why1: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/why konstant/expert-matching-algorithms.svg`,
      why2: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/why konstant/robust-security-measures.svg`,
      why3: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/why konstant/intuitive-ui-ux-design.svg`,
      why4: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/why konstant/cross-platform-development.svg`,
      why5: `${process.env.NEXT_PUBLIC_IMAGE_BASE_URL}/assets/images/dating_app/why konstant/scalability.svg`,
    },
  },
};
